import { Component } from '@angular/core';

@Component({
    selector: 'app-product-warehouses',
    templateUrl: './product-warehouses.component.html',
    styleUrl: './product-warehouses.component.sass',
    standalone: false
})
export class ProductWarehousesComponent {

}
